<div id="event" class="events">
  <div class="events__carousel">
    <app-carousel-vertical [items]="feedbacks" [reverse]="reverse">
      <ng-template let-item="item">
        <app-feedback-card [feedback]="item" class="events__carousel__item"/>
      </ng-template>
    </app-carousel-vertical>
  </div>
</div>
